import {SchemaTag, Tag} from 'folder-items/FileConstants';
import {AssaySchema} from 'results/assay-schemas/AssaySchemaConstants';
import {AssayRun} from 'results/assays/AssayRecordConstants';
import {getTagsForFields} from 'results/assays/getTagForField';
import {SchemaField} from 'schemas/fields/SchemaFieldConstants';
import {getInitialTags} from 'schemas/tags/TagUtil';

import {DisplayConfig} from '../AttachmentConstants';

export function computeVisibleRunFields(
  runSchema: AssaySchema,
  displayConfig: DisplayConfig | null = null
): Array<SchemaField> {
  if (displayConfig) {
    return runSchema.allFields.filter(
      (field: SchemaField) => !displayConfig.hiddenFields.includes(field.name)
    );
  } else {
    // If there is no display config set yet, default to showing currently not-archived fields
    return runSchema.fields;
  }
}

export function getVisibleRunTags(
  visibleFields: Array<SchemaField>,
  assayRun: AssayRun | undefined
): Array<SchemaTag> {
  if (assayRun) {
    return getTagsForFields(visibleFields, assayRun.allTags);
  } else {
    return getInitialTags(visibleFields);
  }
}

export function getEditableRunTags(
  visibleFields: Array<SchemaField>,
  assayRun: AssayRun,
  versionedTags: Array<Tag> | null
): Array<SchemaTag> {
  if (versionedTags) {
    return getTagsForFields(visibleFields, versionedTags);
  }
  return getTagsForFields(visibleFields, assayRun.tags);
}
